import React from 'react';
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ isLoggedIn, children }) => {

    const location = useLocation();

    if (!isLoggedIn) {
        const redirectPath = `${location.pathname}${location.search}`;
        return <Navigate to={`/login?redirect=${encodeURIComponent(redirectPath)}`} replace />;
    }
    return children;
};
export default PrivateRoute;